document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".download-btn").forEach(btn => {
        btn.addEventListener("click", () => {
            const val = btn.getAttribute("data_pdf_link");
            const iframe = document.getElementById("frame_y-71o7kcsyLBcFwQ68uHBg");
            if (iframe && val) {
                iframe.contentWindow.postMessage({ type: "PDF_LINK", data: val }, "*");
            }
        });
    });
});